/**
 * verifyOtpAPI resolves with the axios response on success, but with the raw
 * error BODY (e.g. {code: 9002}) on HTTP errors, or undefined on network errors.
 * Only a successful response carries data.token; everything else is a failure.
 */
export const otpAccessToken = (res: any): string | null => res?.data?.token ?? null;
